<template>
    <tg-layout>
        <template slot="header">
            <el-row type="flex" justify="space-between">
                <tg-search-tool @on-submit="handleSearch">
                    <tg-date-search
                        ref="dateSearch"
                        size="small"
                        v-model="dateRange"
                        showDateRangePicker
                        
                        
                    ></tg-date-search>
                    <template slot="right"></template>
                </tg-search-tool>
                <el-row type="flex" v-show="hasData">
                    <tg-button
                        round
                        border
                        hoverBorderOnly
                        theme="info"
                        @click.native="handleExport"
                    >
                        <template slot="icon" slot-scope="scope">
                        <i
                            class="tg-icon tg-icon-export"
                            :class="{ active: scope.isHover }"
                        ></i>
                        </template>
                        {{ $t("component.btn.export") }}
                    </tg-button>
                </el-row>
            </el-row>
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            @on-loaded="handleLoaded"
            showPagination
            tableTheme="table-purple"
            >
            <template slot="userfullname" slot-scope="scope">
                <tg-user-full-name
                    :row="scope.row"
                    :column="scope.column"
                ></tg-user-full-name>
            </template>
        </tg-table>
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgButton from "@/components/button/TgButton";
import TgUserFullName from "@/components/slot/TgUserFullName";
import { convertToRows, flatColumns } from "@/utils/table";
import xlsx from "@/utils/xlsx";

import apis from "@/apis";

const api = apis.tg_business.ranking.bet_ranking;

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgSearchTool,
    TgButton,
    TgUserFullName,
  },
  data() {
    return {
        columns: [],
        proxy: api.getData,
        hasData: false,
        dateRange: {}
    }
  },
  computed: {
    request() {
      return {
        ...this.dateRange,
      };
    },
  },
  created() {
    api.getColumns().then((response) => {
        this.columns = response.data;
        this.$refs.table.init();
    });
  },
  methods: {
    handleSearch() {
        this.$refs.table.search(this.request);
    },
    handleExport() {
        let normalColumns = JSON.parse(JSON.stringify(this.columns));
        let headerRow = convertToRows(normalColumns);
        let columns = flatColumns(normalColumns);

        let exportFileName = new Date().toISOString().replace(/[-:.]/g, "");

        this.proxy({...this.request, isExport: true}).then((response) => {
          let data = response.data;
          let ws = xlsx.makeSheet(
            headerRow,
            columns,
            data,
            response.amount_page
          );
          xlsx.exportExcel(ws, exportFileName);
        });
    },
    handleLoaded(response) {
        this.hasData = response.data.length > 0;
    }
  }
}
</script>